/* ==========================================================================
   Paolina Charm Studio - cart handlers  (pr-charm-cart.js)
   Loaded globally from theme.liquid. Handles the grouped "design card"
   controls (copies stepper + remove group) rendered in the cart drawer
   (cart-item.liquid) and on the cart page (main-cart.liquid).

   The card exposes:
     [data-pcs-group]           = design_id
     [data-pcs-copies]          = current copies (chain line qty)
     [data-pcs-lines]           = JSON [{key, qty}, ...] chain + charm lines
   Controls:
     [data-pcs-copies-minus] [data-pcs-copies-plus] [data-pcs-copies-input]
     [data-pcs-remove-group]
   Dormant until a design exists in the cart.
   ========================================================================== */
(function () {
  'use strict';

  var busy = false;

  function updateCartUrl() {
    return (window.theme && theme.routes && theme.routes.cartUpdate) ? theme.routes.cartUpdate : '/cart/update.js';
  }
  function ajaxUrl(u) { return /\.js(\?|$)/.test(u) ? u : (u + '.js'); }

  function onCartPage() {
    return document.body && document.body.classList.contains('template-cart');
  }

  function refresh() {
    if (onCartPage()) {
      window.location.reload();
    } else {
      document.dispatchEvent(new CustomEvent('cart:build'));
    }
  }

  function postUpdates(updates) {
    if (busy) return;
    busy = true;
    fetch(ajaxUrl(updateCartUrl()), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates }),
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); }).then(function () {
      busy = false;
      refresh();
    }).catch(function (err) {
      busy = false;
      console.error('[pcs-cart] update failed', err);
    });
  }

  function card(target) {
    return target.closest ? target.closest('[data-pcs-group]') : null;
  }

  function readLines(cardEl) {
    try { return JSON.parse(cardEl.getAttribute('data-pcs-lines') || '[]'); }
    catch (e) { return []; }
  }

  function scaleCopies(cardEl, newCopies) {
    var copies = parseInt(cardEl.getAttribute('data-pcs-copies'), 10) || 1;
    if (newCopies < 1) newCopies = 1;
    if (newCopies === copies) return;
    var lines = readLines(cardEl);
    var updates = {};
    lines.forEach(function (ln) {
      var perCopy = Math.max(1, Math.round(ln.qty / copies));
      updates[ln.key] = perCopy * newCopies;
    });
    postUpdates(updates);
  }

  function removeGroup(cardEl) {
    var lines = readLines(cardEl);
    var updates = {};
    lines.forEach(function (ln) { updates[ln.key] = 0; });
    if (Object.keys(updates).length) postUpdates(updates);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var minus = t.closest ? t.closest('[data-pcs-copies-minus]') : null;
    var plus = t.closest ? t.closest('[data-pcs-copies-plus]') : null;
    var rem = t.closest ? t.closest('[data-pcs-remove-group]') : null;
    if (minus) {
      var c1 = card(minus); if (!c1) return;
      e.preventDefault();
      scaleCopies(c1, (parseInt(c1.getAttribute('data-pcs-copies'), 10) || 1) - 1);
    } else if (plus) {
      var c2 = card(plus); if (!c2) return;
      e.preventDefault();
      scaleCopies(c2, (parseInt(c2.getAttribute('data-pcs-copies'), 10) || 1) + 1);
    } else if (rem) {
      var c3 = card(rem); if (!c3) return;
      e.preventDefault();
      removeGroup(c3);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target && e.target.matches && e.target.matches('[data-pcs-copies-input]') ? e.target : null;
    if (!input) return;
    var c = card(input); if (!c) return;
    var val = parseInt(input.value, 10);
    if (isNaN(val) || val < 1) val = 1;
    scaleCopies(c, val);
  });
})();
